/** Брендовая монограмма «К»: ink-фон, amber-буква, скругление btn. */
export function Monogram({ size = 32, fontSize = 18 }: { size?: number; fontSize?: number }) {
  return (
    <span
      className="inline-flex items-center justify-center bg-ink rounded-btn"
      style={{ width: size, height: size }}
    >
      <span
        className="font-heading text-amber"
        style={{ fontSize, fontWeight: 700, lineHeight: 1 }}
      >К</span>
    </span>
  );
}
